import React from 'react';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import Message from '@uds/message';
import Badge, { Kind as BadgeKind } from '@uds/badge';
import { cssTheme } from '@uds/theme-utils';
import { Heading06 } from '@uds/typography';
import { css } from 'linaria';

interface OuterProps {
  type: string;
  value: number;
  currency: string;
  intlNamespace?: string;
}

const Saving = ({ type, value, currency, intlNamespace }: OuterProps) => {
  if (type === 'percentage') {
    return (
      <FormattedMessage
        id={`${intlNamespace}.saving.percentage`}
        values={{
          saving: <span>{`${value}%`}</span>,
        }}
      />
    );
  }

  if (type === 'fixed') {
    return (
      <FormattedMessage
        id={`${intlNamespace}.saving.fixed`}
        values={{
          saving: <FormattedNumber value={value} style="currency" currency={currency} />,
        }}
      />
    );
  }

  return null;
};

const getClassNames = () => {
  return {
    root: css`
      margin-left: calc(-1 * ${cssTheme.gu1});
      font-family: ${cssTheme.font.display};
    `,
    percentage: css`
      font-weight: normal;
      color: ${cssTheme.palette.highlight};
      vertical-align: middle;
      display: inline;
    `,
    fixed: css`
      font-weight: normal;
      color: ${cssTheme.palette.highlight};
      vertical-align: middle;
      display: inline;
      text-decoration: line-through;
    `,
  };
};
export const PureSaving = ({ type, value, currency, intlNamespace = 'usf' }: OuterProps) => {
  const classNames = getClassNames();
  // No index signature with a parameter of type 'string' was found on type '{ percentage: string; fixed: string; }'.
  const headingType = type === 'percentage' ? classNames['percentage'] : classNames['fixed'];
  return (
    <span className={classNames.root}>
      <Badge kind={BadgeKind.HIGHLIGHT}>
        <Message id={`${intlNamespace}.saving.badge`} />
      </Badge>{' '}
      <Heading06 className={headingType} component="span">
        <Saving type={type} value={value} currency={currency} intlNamespace={intlNamespace} />
      </Heading06>
    </span>
  );
};

PureSaving.displayName = 'Saving';

export default PureSaving;
